module.exports = __webpack_public_path__ + "static/media/paysafecard@2x.5271c097.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/paysafecard@2x.png
// module id = 592
// module chunks = 9